import type { OpencodeMessagePart } from "schemas/generated/opencode";

import { extractPageRouteFromToolPart } from "@agent-ui/features/chat/utils/pageRouteExtraction";

export type EditedPage = { route: string };

export function getEditedPages(parts: OpencodeMessagePart[]): EditedPage[] {
  const seen = new Set<string>();
  const pages: EditedPage[] = [];

  for (const part of parts) {
    const info = extractPageRouteFromToolPart(part);
    if (!info) {
      continue;
    }

    if (seen.has(info.route)) {
      continue;
    }
    seen.add(info.route);

    pages.push({ route: info.route });
  }

  return pages;
}
